// Ideally we get to a point where we're not exposing this to the frontend; in the meantime it's
// exported from @webapp/shared.
export enum WaffleFlag {
  BNBMainnet = "bnb-mainnet-allowlist",
  BNBTestnet = "bnb-testnet-allowlist",
  GasManagerPredeposit = "gas-manager-predeposit",
  SignerService = "signer-service",
  RaasDashboard = "enable_raas_dashboard",
  Pipelines = "allow_data_platform",
  UsageLimitBanner = "usage_limit_banner",
  UsageLimitBannerHoverState = "usage_limit_banner_hover_state",
  ZKsync = "zksync",
  EthHolesky = "eth-holesky",
  AvaxMainnet = "avax-mainnet-allowlist",
  AvaxFuji = "avax-fuji-allowlist",
  ArbNova = "arb-nova",
  AlchemyMainnet = "alchemy-mainnet",
  AlchemySepolia = "alchemy-sepolia",
  AlchemyInternal = "alchemy-internal",
  WorldChainMainnet = "worldchain-mainnet",
  WorldChainSepolia = "worldchain-sepolia",
  ZetaChain = "zetachain",
  Blast = "blast",
  Scroll = "scroll",
  Linea = "linea",
  Gnosis = "gnosis",
  Fantom = "fantom",
  FlowMainnet = "flow-mainnet-allowlist",
  FlowTestnet = "flow-testnet-allowlist",
  MantleMainnet = "mantle",
  MantleSepolia = "mantle-sepolia",
  Celo = "celo",
  BerachainArtio = "berachain",
  BerachainBArtio = "berachain-bartio-allowlist",
  MetisMainnet = "metis-mainnet-allowlist",
  opBNB = "opbnb",
  PolynomialMainnet = "polynomial-mainnet-allowlist",
  PolynomialSepolia = "polynomial-sepolia-allowlist",
  ShapeMainnet = "shape-mainnet-allowlist",
  ShapeSepolia = "shape-sepolia-allowlist",
  BOBMainnet = "bob-mainnet-allowlist",
  CrossFiTestnet = "crossfi-testnet-allowlist",
  IotaMainnet = "iota-mainnet-allowlist",
  IotaTestnet = "iota-testnet-allowlist",
  ModeMainnet = "mode-mainnet-allowlist",
  ModeSepolia = "mode-sepolia-allowlist",
  MoonbaseAlpha = "moonbase-alpha-allowlist",
  MoonbeamMainnet = "moonbeam-mainnet-allowlist",
  MoonriverMainnet = "moonriver-mainnet-allowlist",
  PalmMainnet = "palm-mainnet-allowlist",
  PalmTestnet = "palm-testnet-allowlist",
  ShidenMainnet = "shiden-mainnet-allowlist",
  ShidenShibuya = "shiden-shibuya-allowlist",
  SeiMainnet = "sei-mainnet-allowlist",
  SeiTestnet = "sei-testnet-allowlist",
  KintoMainnet = "kinto-mainnet-allowlist",
  PlumeTestnet = "plume-testnet-allowlist",
  AnimeTestnet = "anime-sepolia-allowlist",
  RaceMainnet = "race-mainnet-allowlist",
  RaceTestnet = "race-sepolia-allowlist",
  ApeChainMainnet = "apechain-mainnet-allowlist",
  ApeChainCurtis = "apechain-curtis-allowlist",
  ApexMainnet = "apex-mainnet-allowlist",
  BossMainnet = "boss-mainnet-allowlist",
  LensSepolia = "lens-sepolia-allowlist",
  SoneiumMinato = "soneium-minato-allowlist",
}
